import * as C from '@radix-ui/react-checkbox';
import type { ReactNode } from 'react';

import './ui.css';

/**
 * A yes/no choice drawn as a toggle chip (buttons.css `.chip.toggle`, ui.css `.ui-check`):
 * outlined off, ink with a tick on, so the state isn't colour alone. Radix Checkbox: a
 * `role=checkbox` button; its words are its name. `className` replaces `chip toggle`.
 *
 * In a `<form>`, Radix's own Checkbox adds a hidden native input (sized by a ResizeObserver,
 * placed beside the chip) so the form's submit sees it. Our forms read their state from React,
 * so the kit adds that input only when the checkbox is given a `name` to submit under.
 */
export function Checkbox({
	checked,
	onCheckedChange,
	disabled,
	children,
	className = 'chip toggle',
	name,
	testId,
	...aria
}: {
	checked: boolean;
	onCheckedChange: (checked: boolean) => void;
	disabled?: boolean | undefined;
	children: ReactNode;
	className?: string | undefined;
	/** Submit it with its form under this name (adds Radix's hidden native input). */
	name?: string | undefined;
	testId?: string | undefined;
	'aria-label'?: string | undefined;
	'aria-describedby'?: string | undefined;
}) {
	return (
		<C.unstable_Provider checked={checked} onCheckedChange={(c) => onCheckedChange(c === true)} disabled={disabled} name={name}>
			<C.unstable_Trigger className={`${className} ui-check`} data-testid={testId} {...aria}>
				{children}
			</C.unstable_Trigger>
			{name !== undefined && <C.unstable_BubbleInput />}
		</C.unstable_Provider>
	);
}
